import { Tooltip } from "antd";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
const NestedMenu = ({ menus, selectedMenuIds = [], onSelectionChange }) => {
    const [selectedIds, setSelectedIds] = useState(new Set(selectedMenuIds));

    useEffect(() => {
        setSelectedIds(new Set(selectedMenuIds));
    }, [selectedMenuIds]);

    // Function to handle parent-child selection logic
    const toggleSelection = (id, children) => {
        const updatedSelection = new Set(selectedIds);

        if(updatedSelection.has(id)) {
            // If the parent is already selected, remove it and its children
            updatedSelection.delete(id);
            children?.forEach((child) =>
                removeFromSelection(child, updatedSelection),);
        } else {
            // Select the parent and all its children
            updatedSelection.add(id);
            children?.forEach((child) =>
                addToSelection(child, updatedSelection),);
        }

        setSelectedIds(updatedSelection);
        onSelectionChange(Array.from(updatedSelection));
    };

    // Recursive function to add all children to selection
    const addToSelection = (item, selection) => {
        selection.add(item.id);
        item.children?.forEach((child) => addToSelection(child, selection));
    };

    // Recursive function to remove all children from selection
    const removeFromSelection = (item, selection) => {
        selection.delete(item.id);
        item.children?.forEach((child) =>
            removeFromSelection(child, selection),);
    };

    // Recursive function to render menu items

    const renderMenu = (items) => (
        <ul className="pl-4 border-l border-gray-300">
            {items.map((item) => (
                <li key={item.id} className="mb-2">
                    <Tooltip
                        title={
                            !item.is_enabled ? "Possibly Phase 2 Update" : ""
                        }
                        placement="right"
                    >
                        <div
                            className={`flex items-center space-x-2 ${
                                item.is_enabled
                                    ? ""
                                    : "text-gray-400 cursor-not-allowed"
                            }`}
                        >
                            <input
                                type="checkbox"
                                checked={selectedIds.has(item.id)}
                                onChange={() =>
                                    item.is_enabled &&
                                    toggleSelection(item.id, item.children)
                                }
                                disabled={!item.is_enabled}
                                className="cursor-pointer disabled:cursor-not-allowed"
                            />
                            <span>{item.title}</span>
                        </div>
                    </Tooltip>
                    {item.children?.length > 0 && renderMenu(item.children)}
                </li>
            ))}
        </ul>
    );

    return (
        <div className="p-5 max-w-lg mx-auto">
            <h2 className="text-2xl font-bold mb-4">Menus</h2>
            {menus.length > 0 ? (
                renderMenu(menus)
            ) : (
                <p>No menu items available</p>
            )}
        </div>
    );
};

NestedMenu.propTypes = {
    menus: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            title: PropTypes.string,
            children: PropTypes.array,
        }),
    ).isRequired,
    selectedMenuIds: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ),
    onSelectionChange: PropTypes.func.isRequired,
};

export default NestedMenu;